import { Injectable } from '@angular/core';
import type {
  NotificationEvent,
  NotificationRealtimeOrderCreatedEvent,
} from '../models/notification-event.model';
import type { NotificationSettings } from '../models/notification-settings.model';
import type { SnackbarInput } from '@cardapio-online/core/snackbar/snackbar';

@Injectable({
  providedIn: 'root',
})
export class NotificationRulesService {
  createFromOrderCreated(
    event: NotificationRealtimeOrderCreatedEvent,
    settings: NotificationSettings
  ): NotificationEvent | null {
    if (!settings.enabled) {
      return null;
    }

    const customerName = event.order.customerName?.trim() || 'Cliente não identificado';
    const deliveryLabel =
      event.order.deliveryType === 'delivery' ? 'Entrega' : 'Retirada';

    return {
      id: event.eventId,
      eventType: 'order.created',
      source: 'orders',
      title: `Novo pedido #${event.order.orderNumber}`,
      description: `${customerName} • ${deliveryLabel} • ${this.formatCurrency(
        event.order.total
      )}`,
      imageUrl: '/assets/public/sino-sentado.png',
      createdAt: event.emittedAt,
      readAt: null,
      variant: 'warning',
      sticky: !settings.autoDismiss,
      durationMs: settings.autoDismiss
        ? settings.durationSeconds * 1000
        : null,
      route: '/admin/pedidos/lista',
      orderId: event.order.id,
    };
  }

  toSnackbar(notification: NotificationEvent): SnackbarInput {
    return {
      id: notification.id,
      title: notification.title,
      description: notification.description,
      imageUrl: notification.imageUrl,
      durationMs: notification.durationMs,
      variant: notification.variant,
      dismissible: true,
    };
  }

  private formatCurrency(value: string | number): string {
    const numericValue = Number(value ?? 0);

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number.isNaN(numericValue) ? 0 : numericValue);
  }
}
